import styled, { css } from 'styled-components';
import {
    mediaMixin,
    spaceMixin,
    Spacer,
    token,
} from '@zillow/constellation';

import { Tag } from '@zillow/zrs-comet';

import MediumIllustrationHouse1x from 'app/shared/images/MediumIllustrationHouse@1x.png';
import MediumIllustrationHouse2x from 'app/shared/images/MediumIllustrationHouse@2x.png';

const THEME_VALIDATION = 'props => props.theme && props.theme.ns';
const LISTED_FOR_RENT = 'LISTED FOR RENT';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: space-between;

    ${mediaMixin('lg', css`
        flex-direction: row;
        align-items: center;
    `)}
`;

export const StyledMobileStatusSpacer = styled(Spacer)`
    ${mediaMixin('lg', css`
       display: none;
    `)}
`;


export const StyledPhoto = styled.div`
    ${mediaMixin('lg', css`
        margin-right: ${spaceMixin('sm')};
    `)}
`;

export const StyledPropertyPhotoContainer = styled.div`
    width: 100%;
    height: 168px;
    border-radius: ${spaceMixin(0.5)};
    margin-bottom: ${spaceMixin('sm')};

    background-repeat: no-repeat;
    background-position: center center;
    background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '105px')};
    background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse2x)});

    ${mediaMixin('lg', css`
        background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse1x)});
        height: 115px;
        min-width: 115px;
        max-width: 115px;
        margin-right: ${spaceMixin('sm')};
        margin-bottom: 0px;
    `)}

    ${mediaMixin('xl', css`
        height: 124px;
        min-width: 176px;
    `)}

    ${props => THEME_VALIDATION && css`
        background-color: ${props.theme.ns().colors.aqua500};
        background-color: ${token('colors.aqua600')};
    `}
`;

export const StyledMobileStatusTag = styled(Tag)`
    border-radius: 10px;
    margin-top: ${spaceMixin('xs')};
    margin-left: ${spaceMixin('xs')};
    background-color: ${({ status }) => (status === LISTED_FOR_RENT ? token('colors.purple600') : '')};
    display: inline-block;
    color: ${token('colors.white')};
`;

export const StyledScrollContainer = styled.div`
    position: ${({ isScrolledMobile }) => (isScrolledMobile ? 'fixed' : 'inherit')};
    top: 0;
    width: 100%;
    padding: ${({ isScrolledMobile }) => (isScrolledMobile ? '16px' : '0px')};
    background-color: white;
    z-index: ${({ isScrolledMobile }) => (isScrolledMobile ? '9999' : '0')};
    box-shadow: ${({ isScrolledMobile }) => (isScrolledMobile ? ' 5px 5px 5px rgba(0, 0, 0, 0.1)' : '0')};

    ${mediaMixin('lg', css`
        position: inherit;
        z-index: 0px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `)}
`;
